import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Color } from '@sunrun/mui-theme';
import MultipleOpptys from './MultipleOpptys';

const Container = styled.div`
  // to override style coming from SideNavbar in component library
  // all other items have z-index of 30, need to make it higher
  z-index: 40 !important;
  margin: 10px 15px;
  padding: 5px 0 20px;
  border-bottom: 1px solid ${Color.WHITE};
`;

const SingleOpptys = styled.div`
  text-align: center;
`;

const AddressSelector = ({ address, changeServiceContract, opptyCount, selectedOption, options, isPVHasEV }) => {
  return (
    <Container>
      {opptyCount > 1 && (
        <MultipleOpptys changeServiceContract={changeServiceContract} selectedOption={selectedOption} options={options} isPVHasEV={isPVHasEV} />
      )}
      {opptyCount === 1 && address && <SingleOpptys>{address}</SingleOpptys>}
    </Container>
  );
};

AddressSelector.propTypes = {
  address: PropTypes.string,
  changeServiceContract: PropTypes.func.isRequired,
  opptyCount: PropTypes.number,
  options: PropTypes.array.isRequired,
  selectedOption: PropTypes.string,
  isPVHasEV: PropTypes.bool,
};

AddressSelector.defaultProps = {
  address: null,
  opptyCount: 1,
  selectedOption: null,
  isPVHasEV: false,
};

export default AddressSelector;
